import { Chip } from '@bp/ui-components';

/**
 * Shared "Beta" marker for the (Timefold) solver surfaces — toolbar actions, the analyze/score-debug
 * modals, the generator wizard and the run banner. Timefold is currently the only available engine,
 * so every solver surface is a Timefold surface.
 */
export const BetaChip = () => <Chip value='Beta' bgColor='var(--color-primary-light)' color='var(--color-grey)' />;
